import { Cancel } from '@mui/icons-material';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import { useNavigate, useLocation } from 'react-router-dom';

const PaymentCancel = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    
    // Debug logging to understand redirect behavior
    useEffect(() => {
        console.log('[PaymentCancel] Component mounted');
        console.log('[PaymentCancel] Current URL:', window.location.href);
        console.log('[PaymentCancel] Location search:', location.search);
        
        const searchParams = new URLSearchParams(location.search);
        const source = searchParams.get('source');
        console.log('[PaymentCancel] Source:', source);
    }, [location]);

    // Function to open the HelpScout Beacon chat widget
    const openChatSupport = () => {
        if (window.Beacon) {
            window.Beacon('open');
            window.Beacon('navigate', '/ask/message');
        }
    };

    return (
        <Paper sx={{
            maxWidth: 600,
            mx: 'auto',
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            borderRadius: 2,
            boxShadow: 3
        }}>
            <Cancel sx={{
                fontSize: 64,
                color: 'error.main',
                mb: 2
            }} />

            <Typography variant="h4" gutterBottom>
                {t('plans.payment.cancel.title')}
            </Typography>

            <Typography variant="body1" sx={{ mb: 4 }}>
                {t('plans.payment.cancel.description')}
            </Typography>

            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 2
            }}>
                <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={() => {
                        const searchParams = new URLSearchParams(location.search);
                        const source = searchParams.get('source');
                        console.log('[PaymentCancel] Button clicked, source:', source);
                        
                        // Navigate based on source, defaulting to tax-reports for our new direct flow
                        const destination = source === 'tax_reports' ? '/tax-reports' : '/plans';
                        console.log('[PaymentCancel] Navigating to:', destination);
                        navigate(destination);
                    }} 
                    sx={{ mr: 2 }}
                >
                    {t('plans.payment.cancel.button')}
                </Button>
                <Button variant="outlined" onClick={openChatSupport}>
                    Contact Support
                </Button>
            </Box>
        </Paper>
    );
};

export default PaymentCancel;
